<header class=" shadow-sm">
  <div class="navbar-container">

  <!-- Navbar -->
    <nav id="main-navbar" class="navbar desktop-nav py-0 navbar-expand-lg navbar-dark bg-gradient sticky-top">
    <!-- Container wrapper -->
    <div class="container-fluid">
    <!-- Toggle button -->
    <button mdbBtn class="navbar-toggler " type="button"
      (click)="navbarSupportedContent.toggle()"
      [attr.aria-expanded]="!navbarSupportedContent.collapsed"
      aria-controls="collapseNavbar">
      <i class="fas fa-bars"></i>
    </button>

    <!-- Collapsible wrapper -->
    <div mdbCollapse #navbarSupportedContent="mdbCollapse" class="collapse navbar-collapse" id="collapseNavbar">
      <!-- Navbar brand -->
      <a class="navbar-brand mb-n2" href="#">
        <img class="finlogo" alt="fmb logo" style="height: 71px; width:175px;" src="assets/finbond_logo.png"
        loading="lazy" />
      </a>

      <!-- Left links -->
        <ul class="navbar-nav me-auto mb-1 mb-lg-0">
          <div *ngFor="let menu of MenuList$ | async; let i = index;" >

          <div *ngIf="!menu.hasSubmenu; else submenu">
            <li class="nav-item nav-pills">
              <a [routerLink]="menu.component" (click)="closeCollapsedMenu(navbarSupportedContent)" style="color: #fafafa;" mdbWavesEffect class="nav-link hover-zoom hover-shadow rounded-1" [ariaCurrentWhenActive]="'page'" routerLinkActive="active"
              >{{menu.menu}}</a>
            </li>
          </div>
          <ng-template #submenu>
            <!-- Dropdown -->
            <li mdbDropdown class="nav-item nav-pills dropdown hover-shadow hover-zoom">
              <a
                class="nav-link dropdown-toggle"
                style="color: #fafafa;"
                id="navbarDropdownMenuLink"
                role="button"
                mdbDropdownToggle
                aria-expanded="false"
              >
              {{menu.menu}}
            </a>
              <ul mdbDropdownMenu  class="dropdown-menu nav-link" aria-labelledby="navbarDropdownMenuLink">
                <li *ngFor="let asubmenu of menu.submenus; let i=index">
                  <a [routerLink]="asubmenu.component" (click)="closeCollapsedMenu(navbarSupportedContent)" class="nav-item dropdown-item">
                    {{asubmenu.submenu}}</a>
                  </li>
              </ul>
            </li>
            </ng-template>
          </div>
        </ul>
      <!-- Left links -->
   </div>
    <!-- Collapsible wrapper -->

    <!-- Right elements -->
    <div class="d-flex align-items-center">
         <ng-container>
            <div *ngIf="userService.LMSUserLoggedIn$; else nouser">
              <span class="d-none d-md-flex align-items-center justify-content-center">
                <!-- Display different icons based on consultantProcessMode -->
                <i class="fa-solid fa-lg me-2 text-white"
                [ngClass]="{ 'fa-desktop' : (userService.consultantProcessMode === 'desktop'), 'fa-tablet' : (userService.consultantProcessMode === 'field') }"></i>
                <label class="fs-5 hover-zoom"
                  [mdbPopover]="tokenRef"
                  mdbPopoverTitle="Layout Settings"
                  placement="bottom"
                  [class.text-white]="useractioncolor ===  3 || useractioncolor === 5">
                  {{userDisplay}}
                </label>
                <div class="nav-item hover-zoom hover-shadow ms-1">
                  <a type="button" class="btn btn-sm rounded-1"
                  data-mdb-ripple-color="#ffffff"
                  style="color: #fafafa; box-shadow: none; cursor: pointer;"  (click)="logout()"> <!--*ngIf="isLoggedIn"-->
                    <i class="fas fa-power-off fa-fw "></i>
                    Logout
                  </a>
              </div>
              </span>
            </div>
             <ng-template #nouser>
            </ng-template>

          </ng-container>
          <div *ngIf="isVisible" class="tribute-ribbon">
            <div class="container">
              <div class="content">
                <span class="symbol" [mdbPopover]="popoverTemplate">✦</span>
                <label class="version-label label-small text-sm-end">{{version}}</label>
                <!-- <p class="message">
                  This release is dedicated to the memory of <strong>Steve Nortje</strong>,
                  whose vision as a designer and skill as a developer helped build the foundation of LMS.
                </p> -->
              </div>
              <!-- <button (click)="dismiss()" class="close-icon" title="Dismiss tribute">&times;</button> -->
            </div>
            <ng-template #popoverTemplate>
              <div *ngIf="showTribute" class="text-center popover-body">
                <p class="tribute-text ">
                  This release is dedicated to the memory of <strong class="m-1"><u>Steve Nortje</u></strong>,
                  whose vision as a designer and skill as a developer helped build the foundation of LMS.
                </p>
              </div>
            </ng-template>
          </div>
          <!-- <label class="version-label label-small text-sm-end">{{version}}</label> -->
    </div>

    <!-- Popover Template for Layout Toggle -->
    <ng-template #tokenRef>
      <div class="p-2">
        <!-- Layout Toggle (only in debug mode) -->
        <div *ngIf="showLayoutToggle" class="d-flex flex-column">
          <label class="mb-2" style="font-size: 0.875rem;">Landing Page Layout</label>
          <div class="form-check form-switch">
            <input
              id="landingLayoutToggle"
              class="form-check-input"
              type="checkbox"
              [(ngModel)]="useNewLandingLayout"
              (change)="toggleLandingLayout()"
            >
            <label class="form-check-label" for="landingLayoutToggle">
              {{ useNewLandingLayout ? 'New Layout' : 'Old Layout' }}
            </label>
          </div>
        </div>

        <hr *ngIf="showLayoutToggle && showStyleToggle" class="my-2">

        <div *ngIf="showStyleToggle" class="d-flex flex-column">
          <label class="mb-2" style="font-size: 0.875rem;">Global Overrides</label>
          <div class="form-check form-switch mb-2">
            <input
              id="globalOverridesToggle"
              class="form-check-input"
              type="checkbox"
              [checked]="globalOverridesEnabled"
              (change)="onGlobalOverridesChange($any($event.target).checked)"
            >
            <label class="form-check-label" for="globalOverridesToggle">
              {{ globalOverridesEnabled ? 'Enabled' : 'Disabled' }}
            </label>
          </div>

          <button class="mobile-toggle" aria-label="Toggle navigation" (click)="onMenuClick()">
            <i class="fa-solid fa-bars"></i>
          </button>
        </div>

        <hr class="my-2">

        <!-- Theme Switcher -->
        <div class="d-flex flex-column">
          <label class="mb-2" style="font-size: 0.875rem;">App Theme</label>
          <div class="btn-group w-100" role="group" aria-label="Theme selector">
            <button type="button"
              class="btn btn-sm"
              [class.btn-primary]="(global_utility.currentThemeSubject | async) === ''"
              [class.btn-outline-secondary]="(global_utility.currentThemeSubject | async) !== ''"
              (click)="global_utility.setAppTheme('')">
              Default
            </button>
            <button type="button"
              class="btn btn-sm"
              [class.btn-primary]="(global_utility.currentThemeSubject | async) === 'lmsv2'"
              [class.btn-outline-secondary]="(global_utility.currentThemeSubject | async) !== 'lmsv2'"
              (click)="global_utility.setAppTheme('lmsv2')">
              LMS v2
            </button>
            <button type="button"
              class="btn btn-sm"
              [class.btn-primary]="(global_utility.currentThemeSubject | async) === 'wow'"
              [class.btn-outline-secondary]="(global_utility.currentThemeSubject | async) !== 'wow'"
              (click)="global_utility.setAppTheme('wow')">
              WoW
            </button>
          </div>
        </div>
      </div>
    </ng-template>

    <!-- Right elements -->
    </div>
    <!-- Container wrapper -->
    </nav>
    <!-- Navbar -->
  </div>
</header>
